import { render, staticRenderFns } from "./civilOrder1.vue?vue&type=template&id=c6edd9a0&scoped=true&"
import script from "./civilOrder1.vue?vue&type=script&lang=js&"
export * from "./civilOrder1.vue?vue&type=script&lang=js&"
import style0 from "./civilOrder1.vue?vue&type=style&index=0&id=c6edd9a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6edd9a0",
  null
  
)

export default component.exports